import { Workflow } from 'lucide-react'

export function WorkflowDefinitionsEmptyState() {
  return (
    <div data-testid="workflow-definitions-empty-state" className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16">
      <Workflow className="h-12 w-12 text-muted-foreground" />
      <h3 className="mt-4 text-lg font-semibold">No workflow definitions yet</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Create a workflow definition to automate your development pipeline.
      </p>
    </div>
  )
}
